import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import validate from 'validate.js';
import { Grid } from '@mui/material';
import moment from 'moment';
import {
  DialogDefaultV2,
  TabFormV2,
  InputV2,
  UsuarioSelectV2,
  ArquivoContainerV2,
} from '../../../components/v2';
import * as selectorsDrones from '../../../store/drone/reducer';
import * as actionsDrones from '../../../store/drone/actions';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as Role from '../../../constants/role';
import HistoricoTab from './HistoricoTab';

const schema = {
  modelo: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  numSerieDrone: { presence: { allowEmpty: false, message: 'é obrigatório' } },
};

const Formulario = ({ saveDrone, updateDrone, selectedDrone, findDroneById, open, id, onClose, authData }) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});

  const isAdmin = authData && (authData.role === Role.ADMIN || authData.role === Role.SUPER_ADMIN);

  useEffect(() => {
    if (open) {
      setValues({
        criadoPor: authData.id,
        criadoPorName: authData.nome,
        dataInclusao: moment().format('DD/MM/YYYY HH:mm:ss'),
      });
    } else {
      setValues({});
    }
  }, [authData, open]);

  useEffect(() => {
    if (id) findDroneById(id);
  }, [id, findDroneById]);

  useEffect(() => {
    if (id && selectedDrone && id === selectedDrone.id) {
      setValues(selectedDrone);
    }
  }, [id, selectedDrone]);

  const handleChange = (event) => setValues({ ...values, [event.target.name]: event.target.value });

  const onSave = () => {
    const erros = validate(values, schema);
    setErrors(erros || {});
    if (!erros) {
      const callback = (success) => { if (success) { setValues({}); onCloseLocal(true); } };
      if (values.id) updateDrone(values, callback);
      else saveDrone(values, callback);
    }
  };

  const onCloseLocal = (isSave) => {
    setErrors({});
    onClose(isSave);
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title="Drone"
      confirmMessage="Salvar"
      maxWidth="md"
      fullWidth
      readOnly={!isAdmin}
    >
      <TabFormV2
        tabPanels={[
          {
            label: 'Informações Básicas',
            disabled: false,
            element: (
              <Grid container spacing={2}>
                <Grid size={{ xs: 4 }}>
                  <InputV2
                    error={!!(errors.modelo)}
                    isRequired
                    label="Modelo"
                    name="modelo"
                    onChange={handleChange}
                    value={values.modelo || ''}
                    disabled={!isAdmin}
                  />
                </Grid>
                <Grid size={{ xs: 4 }}>
                  <InputV2
                    error={!!(errors.numSerieDrone)}
                    isRequired
                    label="Série do drone"
                    name="numSerieDrone"
                    onChange={handleChange}
                    value={values.numSerieDrone || ''}
                    disabled={!isAdmin}
                  />
                </Grid>
                <Grid size={{ xs: 4 }}>
                  <InputV2
                    label="Série do rádio"
                    name="numSerieRadio"
                    onChange={handleChange}
                    value={values.numSerieRadio || ''}
                    disabled={!isAdmin}
                  />
                </Grid>
                <Grid size={{ xs: 4 }}>
                  <InputV2
                    label="Código SISANT"
                    name="codigoSisant"
                    onChange={handleChange}
                    value={values.codigoSisant || ''}
                    disabled={!isAdmin}
                  />
                </Grid>
                <Grid size={{ xs: 4 }}>
                  <InputV2
                    label="Código ANATEL"
                    name="codigoAnatel"
                    onChange={handleChange}
                    value={values.codigoAnatel || ''}
                    disabled={!isAdmin}
                  />
                </Grid>
                <Grid size={{ xs: 4 }}>
                  <InputV2
                    label="Apólice de seguro"
                    name="numApoliceSeguro"
                    onChange={handleChange}
                    value={values.numApoliceSeguro || ''}
                    disabled={!isAdmin}
                  />
                </Grid>
                <Grid size={{ xs: 6 }}>
                  <UsuarioSelectV2
                    ativo
                    grupos={[Role.ADMIN, Role.INSPETOR]}
                    onSelect={(inspetorId) => setValues({ ...values, inspetorId })}
                    value={values.inspetorId}
                    label="Inspetor"
                    disabled={!isAdmin}
                  />
                </Grid>
                <Grid size={{ xs: 3 }}>
                  <InputV2 label="Criado Por" disabled value={values.criadoPorName || ''} />
                </Grid>
                <Grid size={{ xs: 3 }}>
                  <InputV2 label="Data Inclusão" disabled value={values.dataInclusao || ''} />
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <InputV2
                    label="Outras informações"
                    name="informacao"
                    onChange={handleChange}
                    value={values.informacao || ''}
                    rows={3}
                    multiline
                    disabled={!isAdmin}
                  />
                </Grid>
                <ArquivoContainerV2
                  arquivos={values.arquivos}
                  onSave={(arquivos) => setValues({ ...values, arquivos })}
                  disabled={!isAdmin}
                />
              </Grid>
            ),
          },
          {
            label: 'Histórico',
            disabled: !id,
            element: (
              <HistoricoTab
                idDrone={id}
                historico={values.historico || []}
              />
            ),
          },
        ]}
      />
    </DialogDefaultV2>
  );
};

const mapStateToProps = (state) => ({
  selectedDrone: selectorsDrones.getSelectedDrone(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ ...actionsDrones }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Formulario));
